import { Box, Button, Flex, Heading, HStack, Image, SimpleGrid, Spinner, Stack, Tag, Text } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import ContentErrorHandler from 'components/ContentErrorHandler';
import { BLUE, BLUE_DARKER } from 'constants/colors';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetUmkmByCategoryQuery, useGetUmkmCategoryQuery } from './api';

export default function UmkmByCategory() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const navigate = useNavigate();

  const { data: category, error: categoryError, isLoading: categoryLoading } = useGetUmkmCategoryQuery(categoryId!);
  const { data: umkmList, error: umkmError, isLoading: umkmLoading } = useGetUmkmByCategoryQuery(categoryId!);

  return (
    <ContentErrorHandler isError={categoryError || umkmError} isLoading={categoryLoading || umkmLoading}>
      <Box bg="white" minH="100vh" py={10}>
        <Box display="flex" flexDirection="column" gap={8} maxW="1200px" mx="auto" px={4}>
          <Button
            alignSelf="flex-start"
            onClick={() => navigate('/umkm')}
            borderColor={BLUE}
            color={BLUE}
            variant="outline"
            _hover={{ bg: BLUE, color: 'white' }}
          >
            ← Kembali ke Kategori
          </Button>

          <Heading color={BLUE_DARKER} size="xl" textAlign="center">
            {category?.name}
          </Heading>

          {category?.description && (
            <Text color="gray.600" textAlign="center" w="100%">
              {category.description}
            </Text>
          )}

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} w="100%">
            {umkmList?.map((umkm) => (
              <Box
                key={umkm.id}
                overflow="hidden"
                cursor="pointer"
                transition="transform 0.2s"
                _hover={{ transform: 'scale(1.05)', shadow: 'xl' }}
                onClick={() => navigate(`/umkm/detail/${umkm.id}`)}
                bg="white"
                borderRadius="md"
                shadow="md"
              >
                {umkm.images && umkm.images.length > 0 && <Image src={umkm.images[0]} alt={umkm.name} h="200px" w="100%" objectFit="cover" />}
                <Box p={4}>
                  <Stack spacing={3}>
                    <Heading size="md" color={BLUE}>
                      {umkm.name}
                    </Heading>

                    {umkm.owner && (
                      <Text fontSize="sm" color="gray.500">
                        Pemilik: {umkm.owner.name}
                      </Text>
                    )}

                    {umkm.address && (
                      <Text fontSize="sm" color="gray.600" noOfLines={2}>
                        📍 {umkm.address}
                      </Text>
                    )}

                    {umkm.description && (
                      <Text color="gray.600" noOfLines={3}>
                        {umkm.description}
                      </Text>
                    )}

                    <HStack spacing={2} flexWrap="wrap">
                      {umkm.categories?.map((cat) => (
                        <Tag key={cat.id} size="sm" bg={BLUE} color="white">
                          {cat.name}
                        </Tag>
                      ))}
                    </HStack>

                    <Button borderColor={BLUE} color={BLUE} variant="outline" size="sm" onClick={() => navigate(`/umkm/detail/${umkm.id}`)}>
                      Lihat Produk
                    </Button>

                    {umkm.whatsappNumber && (
                      <Button
                        leftIcon={<FaWhatsapp />}
                        bg={BLUE}
                        color="white"
                        size="sm"
                        _hover={{ bg: BLUE_DARKER }}
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(`https://wa.me/${umkm.whatsappNumber}`, '_blank');
                        }}
                      >
                        Hubungi via WhatsApp
                      </Button>
                    )}
                  </Stack>
                </Box>
              </Box>
            ))}
          </SimpleGrid>

          {(!umkmList || umkmList.length === 0) && !umkmLoading && (
            <Text fontSize="lg" color="gray.500" textAlign="center" w="100%">
              Belum ada UMKM dalam kategori ini
            </Text>
          )}
        </Box>
      </Box>
    </ContentErrorHandler>
  );
}
